import { buildMeta } from "../routeMeta";

export { default } from "../../src/pages/landing/index";

export function meta(args) {
  return buildMeta(
    {
      description:
        "Visualize global trade data and economic growth opportunities for every country.",
    },
    args,
  );
}
